
// export interface WindowWithDatalayer<T> extends Window {
//   dataLayer: T[]
// }

export type DatalayerPayload = {
  category: string
  action: string
}

export const pushEventToDatalayer = (payload: DatalayerPayload) => {
  if (!!(window as any).dataLayer) {
    (window as any).dataLayer.push({
      event: "event.boonedam",
      ...payload
    })
  }
}